import './version';

export {
  // eslint-disable-next-line @fluentui/ban-context-export
  IconContext,
  IconProvider,
  useIconSubset,
} from './IconProvider';
export type { IconProviderProps } from './IconProvider.types';
